import { c as _c } from "react/compiler-runtime";
interface FamilyMedicineIconProps {
  size?: number;
  className?: string;
}
const FamilyMedicineIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M22.1666 16.1309V17.1221C22.1666 20.565 19.3745 23.3571 15.9316 23.3571C12.4888 23.3571 9.69668 20.565 9.69668 17.1221V16.6454M22.1666 16.1309C21.0997 16.1309 20.2295 15.2607 20.2295 14.1938C20.2295 13.1269 21.0997 12.2567 22.1666 12.2567C23.2335 12.2567 24.1037 13.1269 24.1037 14.1938C24.1037 15.2607 23.2335 16.1309 22.1666 16.1309ZM5.59552 5.64343H5.17935C4.33188 5.64343 3.64331 6.332 3.64331 7.17947V10.5996C3.64331 14.0727 6.57163 16.8649 10.0977 16.6379C13.3136 16.426 15.75 13.6112 15.75 10.3878V7.17947C15.75 6.332 15.0615 5.64343 14.214 5.64343H13.7978" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== t3 || $[4] !== t5) {
    t7 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}</svg>;
    $[3] = t3;
    $[4] = t5;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
};
export default FamilyMedicineIcon;